{
  "HELP_CENTER": {
    "TITLE": "Центр поддержки",
    "NEW_PAGE": {
      "DESCRIPTION": "Создайте порталы самообслуживания для вашего центра поддержки. Помогите вашим клиентам быстро находить ответы, без ожидания. Оптимизируйте запросы, повысите эффективность агентов и улучшите поддержку клиентов.",
      "CREATE_PORTAL_BUTTON": "Создать портал"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Без названия"
    },
    "HEADER": {
      "FILTER": "Фильтровать по",
      "SORT": "Сортировать по",
      "LOCALE": "Язык",
      "SETTINGS_BUTTON": "Настройки",
      "NEW_BUTTON": "Новая статья",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Опубликовано",
        "DRAFT": "Draft",
        "ARCHIVED": "Архив"
      },
      "TITLES": {
        "ALL_ARTICLES": "Все статьи",
        "MINE": "Мои статьи",
        "DRAFT": "Draft-статьи",
        "ARCHIVED": "Архивированные статьи"
      },
      "LOCALE_SELECT": {
        "TITLE": "Выберите язык",
        "PLACEHOLDER": "Выберите язык",
        "NO_RESULT": "Язык не найден",
        "SEARCH_PLACEHOLDER": "Поиск языка"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Все статьи",
      "PUBLISH_BUTTON": "Опубликовать",
      "MOVE_TO_ARCHIVE_BUTTON": "Переместить в архив",
      "PREVIEW": "Предпросмотр",
      "ADD_TRANSLATION": "Добавить перевод",
      "OPEN_SIDEBAR": "Открыть боковую панель",
      "CLOSE_SIDEBAR": "Закрыть боковую панель",
      "SAVING": "Сохранение...",
      "SAVED": "Сохранено"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Загрузить изображение",
        "UPLOADING": "Загружаем...",
        "SUCCESS": "Изображение успешно загружено",
        "ERROR": "Ошибка при загрузке изображения",
        "UN_AUTHORIZED_ERROR": "У вас нет прав для загрузки изображений",
        "ERROR_FILE_SIZE": "Размер изображения должен быть меньше, чем {size}MB",
        "ERROR_FILE_FORMAT": "Формат изображения должен быть jpg, jpeg или png",
        "ERROR_FILE_DIMENSIONS": "Размеры изображения должны быть меньше, чем 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Вставить якорь",
        "TITLE": "Вставить якорь",
        "SUBMIT": "Вставить",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Настройки статьи",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Категория",
          "TITLE": "Выберите категорию",
          "PLACEHOLDER": "Выберите категорию",
          "NO_RESULT": "Не найдено категорий",
          "SEARCH_PLACEHOLDER": "Поиск категории"
        },
        "AUTHOR": {
          "LABEL": "Автор",
          "TITLE": "Выбрать автора",
          "PLACEHOLDER": "Выбрать автора",
          "NO_RESULT": "Авторов не найдено",
          "SEARCH_PLACEHOLDER": "Поиск автора"
        },
        "META_TITLE": {
          "LABEL": "Мета-заголовок",
          "PLACEHOLDER": "Добавьте мета-заголовок"
        },
        "META_DESCRIPTION": {
          "LABEL": "Мета описание",
          "PLACEHOLDER": "Добавьте мета-описание для лучших SEO результатов..."
        },
        "META_TAGS": {
          "LABEL": "Мета теги",
          "PLACEHOLDER": "Добавить мета-теги, разделенные запятыми..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Архивировать статью",
        "DELETE": "Удалить статью"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Без категории",
      "SEARCH_RESULTS": "Результаты поиска {query}",
      "EMPTY_TEXT": "Поиск статей для вставки в ответы.",
      "SEARCH_LOADER": "Идёт поиск...",
      "INSERT_ARTICLE": "Вставить",
      "NO_RESULT": "Статьи не найдены",
      "COPY_LINK": "Скопировать ссылку статьи в буфер",
      "OPEN_LINK": "Открыть статью в новой вкладке",
      "PREVIEW_LINK": "Предпросмотр статьи"
    },
    "PORTAL": {
      "HEADER": "Порталы",
      "DEFAULT": "По умолчанию",
      "NEW_BUTTON": "Новый портал",
      "ACTIVE_BADGE": "активно",
      "CHOOSE_LOCALE_LABEL": "Выберите локаль",
      "LOADING_MESSAGE": "Загрузка порталов...",
      "ARTICLES_LABEL": "статьи",
      "NO_PORTALS_MESSAGE": "Нет доступных порталов",
      "ADD_NEW_LOCALE": "Добавить новую локаль",
      "POPOVER": {
        "TITLE": "Порталы",
        "PORTAL_SETTINGS": "Настройки портала",
        "SUBTITLE": "У вас есть несколько порталов, и для каждого из них можно задать свои локали.",
        "CANCEL_BUTTON_LABEL": "Отменить",
        "CHOOSE_LOCALE_BUTTON": "Выберите локаль"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "статьи",
            "ADD": "Добавить локаль",
            "VISIT": "Посетить сайт",
            "SETTINGS": "Настройки",
            "DELETE": "Удалить"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Конфигурации портала",
            "ITEMS": {
              "NAME": "Имя",
              "DOMAIN": "Свой домен",
              "SLUG": "Slug",
              "TITLE": "Название портала",
              "THEME": "Цвет темы",
              "SUB_TEXT": "Подтекст портала"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Доступные локали",
            "TABLE": {
              "NAME": "Название локали",
              "CODE": "Код локали",
              "ARTICLE_COUNT": "№ статей",
              "CATEGORIES": "№ категорий",
              "SWAP": "Поменять",
              "DELETE": "Удалить",
              "DEFAULT_LOCALE": "По умолчанию"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Удалить портал",
          "MESSAGE": "Вы уверены, что хотите удалить этот портал",
          "YES": "Да, удалить портал",
          "NO": "Нет, сохранить портал",
          "API": {
            "DELETE_SUCCESS": "Портал успешно удален",
            "DELETE_ERROR": "Ошибка при удалении портала"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Редактировать портал",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Основная информация"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Настройка портала"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Категории"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Локали"
          }
        },
        "CATEGORIES": {
          "TITLE": "Категории в",
          "NEW_CATEGORY": "Новая категория",
          "TABLE": {
            "NAME": "Имя",
            "DESCRIPTION": "Описание",
            "LOCALE": "Локаль",
            "ARTICLE_COUNT": "№ статей",
            "ACTION_BUTTON": {
              "EDIT": "Редактировать категорию",
              "DELETE": "Удалить категорию"
            },
            "EMPTY_TEXT": "Категорий не найдено"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Обновить основные настройки"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Информация справочного центра",
            "BODY": "Основная информация о портале"
          },
          "CUSTOMIZATION": {
            "TITLE": "Настройка справочного центра",
            "BODY": "Настройка портала"
          },
          "FINISH": {
            "TITLE": "Ура! 🎉",
            "BODY": "Всё готово!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Назад",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Создать портал",
            "TITLE": "Информация справочного центра",
            "CREATE_BASIC_SETTING_BUTTON": "Создать базовые настройки портала"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Настройки портала",
            "TITLE": "Настройка справочного центра",
            "UPDATE_PORTAL_BUTTON": "Обновить настройки портала"
          },
          "FINISH_PAGE": {
            "TITLE": "Ура!🎉 Все готово!",
            "MESSAGE": "Теперь вы можете видеть этот созданный портал на вашей странице порталов.",
            "FINISH": "Перейти на страницу всех порталов"
          }
        },
        "LOGO": {
          "LABEL": "Логотип",
          "UPLOAD_BUTTON": "Загрузить логотип",
          "HELP_TEXT": "Этот логотип будет показан в заголовке портала.",
          "IMAGE_UPLOAD_SUCCESS": "Логотип успешно загружен",
          "IMAGE_UPLOAD_ERROR": "Логотип успешно удалён",
          "IMAGE_DELETE_ERROR": "Ошибка при удалении логотипа"
        },
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя портала",
          "HELP_TEXT": "Название будет использоваться на публичном портале.",
          "ERROR": "Необходимо указать имя"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug портала для URL",
          "ERROR": "Необходимо указать Slug"
        },
        "DOMAIN": {
          "LABEL": "Пользовательский домен",
          "PLACEHOLDER": "Пользовательский домен портала",
          "HELP_TEXT": "Добавьте только если вы хотите использовать пользовательский домен для ваших порталов. Например: {exampleURL}",
          "ERROR": "Введите корректный URL домена"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Домашняя ссылка",
          "PLACEHOLDER": "Ссылка на главную страницу портала",
          "HELP_TEXT": "Ссылка, используемая для возврата с портала на главную страницу. Например: {exampleURL}",
          "ERROR": "Введите корректный URL главной страницы"
        },
        "THEME_COLOR": {
          "LABEL": "Цвет темы портала",
          "HELP_TEXT": "Этот цвет будет отображаться в качестве цвета темы портала."
        },
        "PAGE_TITLE": {
          "LABEL": "Название страницы",
          "PLACEHOLDER": "Заголовок страницы портала",
          "HELP_TEXT": "Название будет использоваться на публичном портале.",
          "ERROR": "Необходимо указать название"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст заголовка",
          "PLACEHOLDER": "Текст заголовка портала",
          "HELP_TEXT": "Текст заголовка портала будет использоваться на публичном портале.",
          "ERROR": "Необходимо ввести текст заголовка портала"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Портал создан успешно.",
          "ERROR_MESSAGE_FOR_BASIC": "Не удалось создать портал. Попробуйте еще раз.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Портал успешно обновлен.",
          "ERROR_MESSAGE_FOR_UPDATE": "Не удалось обновить портал. Попробуйте еще раз."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Добавить новую локаль",
        "SUB_TITLE": "Это добавляет новую локализацию в ваш список доступных переводов.",
        "PORTAL": "Портал",
        "LOCALE": {
          "LABEL": "Локаль",
          "PLACEHOLDER": "Выберите локаль",
          "ERROR": "Требуется локаль"
        },
        "BUTTONS": {
          "CREATE": "Создать локаль",
          "CANCEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Локаль успешно добавлена",
          "ERROR_MESSAGE": "Не удалось добавить локаль. Попробуйте еще раз."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Локаль по умолчанию успешно обновлена",
          "ERROR_MESSAGE": "Не удалось обновить локаль по умолчанию. Повторите попытку."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Локаль успешно удалена из портала",
          "ERROR_MESSAGE": "Невозможно удалить локаль из портала. Повторите попытку."
        }
      }
    },
    "TABLE": {
      "404": "Нет статей, соответствующих вашему запросу 🔍",
      "LOADING_MESSAGE": "Загрузка статей...",
      "NO_ARTICLES": "Нет доступных статей",
      "HEADERS": {
        "TITLE": "Название",
        "CATEGORY": "Категория",
        "READ_COUNT": "Просмотры",
        "STATUS": "Статус",
        "LAST_EDITED": "Последнее изменение"
      },
      "COLUMNS": {
        "BY": "от",
        "AUTHOR_NOT_AVAILABLE": "Автор недоступен"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Загрузка статьи...",
      "TITLE_PLACEHOLDER": "Название статьи",
      "CONTENT_PLACEHOLDER": "Напишите свою статью здесь",
      "API": {
        "ERROR": "Ошибка при сохранении статьи"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Ошибка при публикации статьи",
        "SUCCESS": "Статья успешно опубликована"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Ошибка при архивации статьи",
        "SUCCESS": "Статья успешно архивирована"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Ошибка при переводе статьи в Draft",
        "SUCCESS": "Статья успешно переведена в Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Подтвердите удаление",
          "MESSAGE": "Вы уверены, что хотите удалить статью?",
          "YES": "Да, удалить",
          "NO": "Нет, не удалять"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Статья успешно удалена",
        "ERROR_MESSAGE": "Ошибка при удалении статьи"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Сначала добавьте заголовок и содержимое статьи — только после этого можно будет изменить настройки"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Поиск статей"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Создать категорию",
        "SUB_TITLE": "Категория будет использоваться в публичном портале для классификации статей.",
        "PORTAL": "Портал",
        "LOCALE": "Локаль",
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя категории",
          "HELP_TEXT": "Название категории будет использоваться на портале общего доступа для классификации статей.",
          "ERROR": "Необходимо указать имя"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug категории для URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Необходимо указать Slug"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Укажите краткое описание категории.",
          "ERROR": "Необходимо описание"
        },
        "BUTTONS": {
          "CREATE": "Создать категорию",
          "CANCEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категория успешно создана",
          "ERROR_MESSAGE": "Не удалось создать категорию"
        }
      },
      "EDIT": {
        "TITLE": "Редактировать категорию",
        "SUB_TITLE": "Изменение категории обновит категорию на портале.",
        "PORTAL": "Портал",
        "LOCALE": "Локаль",
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя категории",
          "HELP_TEXT": "Название категории будет использоваться на портале общего доступа для классификации статей.",
          "ERROR": "Необходимо указать имя"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug категории для URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Необходимо указать Slug"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Укажите краткое описание категории.",
          "ERROR": "Необходимо описание"
        },
        "BUTTONS": {
          "CREATE": "Обновить категорию",
          "CANCEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категория успешно обновлена",
          "ERROR_MESSAGE": "Не удается обновить категорию"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Категория успешно удалена",
          "ERROR_MESSAGE": "Не удается удалить категорию"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Поиск статей",
      "PLACEHOLDER": "Поиск статей",
      "NO_RESULT": "Статьи не найдены",
      "SEARCHING": "Идёт поиск...",
      "SEARCH_BUTTON": "Поиск",
      "INSERT_ARTICLE": "Вставить ссылку",
      "IFRAME_ERROR": "URL пуст или недействителен. Невозможно отобразить содержимое.",
      "OPEN_ARTICLE_SEARCH": "Вставить статью из справочного центра",
      "SUCCESS_ARTICLE_INSERTED": "Статья успешно вставлена",
      "PREVIEW_LINK": "Предпросмотр статьи",
      "CANCEL": "Закрыть",
      "BACK": "Назад",
      "BACK_RESULTS": "Назад к результатам"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Центр поддержки",
      "DESCRIPTION": "Создайте удобные для пользователя порталы самообслуживания. Помогите пользователям получить доступ к материалам и получите поддержку 24/7. Обновите свою подписку, чтобы включить эту функцию.",
      "SELF_HOSTED_DESCRIPTION": "Создавайте пользовательские порталы самообслуживания. Помогите пользователям получить доступ к материалам и получите поддержку 24/7. Обратитесь к администратору, чтобы включить эту функцию.",
      "BUTTON": {
        "LEARN_MORE": "Узнать больше",
        "UPGRADE": "Обновить"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Несколько порталов",
          "DESCRIPTION": "Создайте несколько порталов справочного центра для разных товаров с использованием одного аккаунта."
        },
        "LOCALES": {
          "TITLE": "Полная поддержка языков",
          "DESCRIPTION": "Локализация портала на вашем языке. Мы поддерживаем все локали и разрешаем переводы для каждой статьи."
        },
        "SEO": {
          "TITLE": "SEO-дружественный дизайн",
          "DESCRIPTION": "Настройте мета-теги для улучшения видимости поисковых систем на наших SEO-страницах."
        },
        "API": {
          "TITLE": "Полная поддержка API",
          "DESCRIPTION": "Используйте портал как headless CMS со сторонними фронтенд-фреймворками с помощью наших API."
        }
      }
    },
    "LOADING": "Загрузка...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} просмотр | {count} просмотров",
          "DROPDOWN_MENU": {
            "PUBLISH": "Опубликовать",
            "DRAFT": "Draft",
            "ARCHIVE": "Архивировать",
            "DELETE": "Удалить"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Опубликовано",
            "ARCHIVED": "Архив"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Без категории"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Все статьи",
          "MINE": "Мои",
          "DRAFT": "Draft",
          "PUBLISHED": "Опубликовано",
          "ARCHIVED": "Архив"
        },
        "CATEGORY": {
          "ALL": "Все категории"
        },
        "LOCALE": {
          "ALL": "Все локали"
        },
        "NEW_ARTICLE": "Новая статья"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Написать статью",
          "SUBTITLE": "Напишите насыщенную статью, давайте начнем!",
          "BUTTON_LABEL": "Новая статья"
        },
        "MINE": {
          "TITLE": "Вы не написали ни одной статьи здесь",
          "SUBTITLE": "Все статьи, написанные вами, показываются здесь для быстрого доступа."
        },
        "DRAFT": {
          "TITLE": "Нет статей в Draft",
          "SUBTITLE": "Draft-статьи будут появляться здесь"
        },
        "PUBLISHED": {
          "TITLE": "Нет опубликованных статей",
          "SUBTITLE": "Опубликованные статьи появятся здесь"
        },
        "ARCHIVED": {
          "TITLE": "В архиве нет статей",
          "SUBTITLE": "Архивные статьи не отображаются на портале, вы можете использовать их для обозначения ненужных или устаревших страниц"
        },
        "CATEGORY": {
          "TITLE": "В этой категории нет статей",
          "SUBTITLE": "Статьи в этой категории будут отображаться здесь"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Новая категория",
        "EDIT_CATEGORY": "Редактировать категорию",
        "CATEGORIES_COUNT": "{n} категория | {n} категорий",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Категории ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} статей) | {categoryName} ({categoryCount} статья)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Категорий не найдено",
        "SUBTITLE": "Категории появятся здесь. Вы можете добавить категорию, нажав на кнопку 'Новая категория'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} статья | {count} статей",
        "EXPAND": "Показать подкатегории",
        "COLLAPSE": "Скрыть подкатегории",
        "MENU": {
          "NEW_ARTICLE": "Новая статья",
          "ADD_SUBCATEGORY": "Добавить подкатегорию",
          "EDIT": "Редактировать",
          "DELETE": "Удалить"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Категория успешно создана",
            "ERROR_MESSAGE": "Не удалось создать категорию"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Категория успешно обновлена",
            "ERROR_MESSAGE": "Не удается обновить категорию"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Категория успешно удалена",
            "ERROR_MESSAGE": "Не удается удалить категорию"
          },
          "CONFIRM": {
            "TITLE": "Удалить категорию",
            "DESCRIPTION": "Вы уверены, что хотите удалить эту категорию? Её статьи станут без категории.",
            "DESCRIPTION_WITH_CHILDREN": "Вы уверены, что хотите удалить эту категорию? Её статьи станут без категории, а {count} подкатегория будет перемещена на верхний уровень. | Вы уверены, что хотите удалить эту категорию? Её статьи станут без категории, а {count} подкатегорий будут перемещены на верхний уровень.",
            "CONFIRM": "Удалить"
          }
        },
        "HEADER": {
          "CREATE": "Создать категорию",
          "EDIT": "Редактировать категорию",
          "DESCRIPTION": "Изменение категории обновит категорию на портале.",
          "PORTAL": "Портал",
          "LOCALE": "Локаль"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Имя",
            "PLACEHOLDER": "Имя категории",
            "ERROR": "Необходимо указать имя"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug категории для URL",
            "ERROR": "Необходимо указать Slug",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Описание",
            "PLACEHOLDER": "Укажите краткое описание категории.",
            "ERROR": "Необходимо описание"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Родительская категория",
            "PLACEHOLDER": "Выберите родительскую категорию",
            "NONE": "Нет (верхний уровень)"
          }
        },
        "BUTTONS": {
          "CREATE": "Создать",
          "EDIT": "Обновить",
          "CANCEL": "Отменить"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Нет доступных локалей | {n} локаль | {n} локалей",
      "NEW_LOCALE_BUTTON_TEXT": "Новая локаль",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} статья | {count} статей",
        "CATEGORIES_COUNT": "{count} категория | {count} категорий",
        "DEFAULT": "По умолчанию",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Сделать по умолчанию",
          "DELETE": "Удалить"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Добавить новую локаль",
        "DESCRIPTION": "Выберите язык, на котором будет написана эта статья. Этот язык будет добавлен в ваш список переводов, и вы сможете добавить другие языки позже.",
        "COMBOBOX": {
          "PLACEHOLDER": "Выберите язык..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Локаль успешно добавлена",
          "ERROR_MESSAGE": "Не удалось добавить локаль. Попробуйте еще раз."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Сохранение...",
          "SAVED": "Сохранено"
        },
        "PREVIEW": "Предпросмотр",
        "PUBLISH": "Опубликовать",
        "DRAFT": "Draft",
        "ARCHIVE": "Архивировать",
        "BACK_TO_ARTICLES": "Назад к статьям"
      },
      "DRAFT": {
        "PENDING_LABEL": "Неопубликованные изменения",
        "PROMOTE": "Опубликовать изменения",
        "DISCARD": "Отменить изменения",
        "PROMOTE_SUCCESS": "Изменения Draft опубликованы в статье",
        "PROMOTE_ERROR": "Не удалось опубликовать изменения Draft",
        "DISCARD_SUCCESS": "Изменения Draft отменены",
        "DISCARD_ERROR": "Не удалось отменить изменения Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "История версий",
        "TITLE": "История версий",
        "BACK": "Назад к статье",
        "LOADING": "Загрузка версий...",
        "EMPTY": "Версий пока нет. Изменения в этой статье будут отображаться здесь.",
        "EMPTY_CONTENT": "В этой версии нет содержимого.",
        "CURRENT_BADGE": "Текущая",
        "RESTORED_BADGE": "Восстановлена",
        "AUTOMATED_USER": "Автоматическое обновление",
        "RESTORE": "Восстановить эту версию",
        "RESTORE_DIALOG": {
          "TITLE": "Восстановить эту версию?",
          "DESCRIPTION": "Статья вернётся к формулировкам этой версии. Ничего не будет потеряно — текущий текст останется в истории, а опубликованная статья будет показывать текущую версию, пока вы не опубликуете изменение.",
          "CONFIRM": "Восстановить"
        },
        "RESTORE_SUCCESS": "Версия восстановлена",
        "RESTORE_ERROR": "Не удалось восстановить эту версию",
        "FETCH_ERROR": "Не удалось загрузить историю версий"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Больше параметров",
        "TRANSLATE": "Перевести",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Без категории",
        "EDITOR_PLACEHOLDER": "Напишите что-нибудь...",
        "HTML_EMBED": {
          "TITLE": "Вставить пользовательский HTML",
          "DESCRIPTION": "Вставьте необработанный HTML, например iframe, embed или фрагмент виджета. Он будет отображён как есть в опубликованной статье.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Вставить"
        },
        "PRIMARY_CATEGORY": "Основная категория"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Параметры статьи",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Мета описание",
        "META_DESCRIPTION_PLACEHOLDER": "Добавить мета-описание",
        "META_TITLE": "Мета-заголовок",
        "META_TITLE_PLACEHOLDER": "Добавить мета-заголовок",
        "META_TAGS": "Мета теги",
        "META_TAGS_PLACEHOLDER": "Добавить мета-теги",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Языковые версии",
        "LANGUAGE_MUTATIONS_EMPTY": "Нет связанных статей",
        "ADD_MUTATION": "Добавить",
        "REMOVE_MUTATION": "Удалить"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Связать языковые версии",
        "SEARCH_PLACEHOLDER": "Поиск статей по заголовку",
        "EMPTY": "Совпадений не найдено",
        "CANCEL": "Отмена",
        "ADD_SELECTED": "Добавить выбранные",
        "SUCCESS": "Версии обновлены",
        "ERROR": "Не удалось обновить версии"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Перевести статью",
        "DESCRIPTION": "Выберите языки, на которые вы хотите перевести эту статью. Уже переведённые языки будут повторно переведены в Draft для проверки.",
        "EMPTY": "Других доступных языков нет",
        "CONNECTED_BADGE": "Переведено",
        "CANCEL": "Отмена",
        "TRANSLATE": "Перевести",
        "SUCCESS": "Перевод скоро начнётся. Переведённые статьи вскоре появятся как языковые версии.",
        "ERROR": "Не удалось запустить перевод"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Ошибка при сохранении статьи"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Новый портал",
      "PORTALS": "Порталы",
      "CREATE_PORTAL": "Создание и управление несколькими порталами",
      "ARTICLES": "статьи",
      "DOMAIN": "домен",
      "PORTAL_NAME": "Имя портала"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Создать новый портал",
      "DESCRIPTION": "Дайте вашему порталу название и создайте удобочитаемый slug для URL. Вы сможете изменить оба этих параметра позже в настройках.",
      "CONFIRM_BUTTON_LABEL": "Создать",
      "NAME": {
        "LABEL": "Имя",
        "PLACEHOLDER": "Руководство пользователя",
        "MESSAGE": "Выберите имя для вашего портала.",
        "ERROR": "Необходимо указать имя"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Необходимо указать Slug",
        "FORMAT_ERROR": "Используйте только буквы, цифры и дефисы, например: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Логотип",
          "IMAGE_UPLOAD_ERROR": "Не удалось загрузить изображение! Попробуйте снова",
          "IMAGE_UPLOAD_SUCCESS": "Изображение успешно добавлено. Нажмите «Сохранить изменения», чтобы сохранить логотип",
          "IMAGE_DELETE_SUCCESS": "Логотип успешно удалён",
          "IMAGE_DELETE_ERROR": "Не удалось удалить логотип",
          "IMAGE_UPLOAD_SIZE_ERROR": "Размер изображения должен быть меньше, чем {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя портала",
          "ERROR": "Необходимо указать имя"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст заголовка",
          "PLACEHOLDER": "Текст заголовка портала"
        },
        "PAGE_TITLE": {
          "LABEL": "Заголовок страницы",
          "PLACEHOLDER": "Заголовок страницы портала"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Ссылка на домашнюю страницу",
          "PLACEHOLDER": "Ссылка на главную страницу портала",
          "ERROR": "Неправильный URL-адрес. Ссылка на главную страницу должна начинаться с 'http://' или 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug портала"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Виджет онлайн чата",
          "PLACEHOLDER": "Выберите виджет онлайн чата",
          "HELP_TEXT": "Выберите виджет онлайн-чата, который появится в вашем центре помощи"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Публичный доступ",
          "HELP_TEXT": "Сделать портал доступным всем по ссылке.",
          "OPTIONS": {
            "PUBLIC": "Да",
            "PRIVATE": "Нет"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Цель ссылки",
          "HELP_TEXT": "Выберите, открывать ли ссылки в статьях в текущем окне или в новом.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Текущее окно",
            "NEW_WINDOW": "Новое окно"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Размер изображения по умолчанию",
          "HELP_TEXT": "Размер, применяемый к каждому изображению, которое вы вставляете в статью. Выберите «Original», чтобы вставлять изображения в их исходном размере и вместо этого выбирать размер для каждого изображения отдельно."
        },
        "BRAND_COLOR": {
          "LABEL": "Цвет бренда"
        },
        "CUSTOM_HTML": {
          "LABEL": "Пользовательский HTML",
          "PLACEHOLDER": "<!-- Вставьте сюда фрагмент кода аналитики или отслеживания -->",
          "HELP_TEXT": "Вставляется в начале тега <body> на каждой странице центра помощи. Используйте его для Google Analytics, Google Tag Manager или любого другого фрагмента кода отслеживания. Код отображается точно так, как он был введён, и не проверяется."
        },
        "SAVE_CHANGES": "Сохранить изменения"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Свой домен",
          "LABEL": "Свой домен:",
          "DESCRIPTION": "Вы можете разместить ваш портал на собственном домене. Например, если ваш сайт — yourdomain.com, и вы хотите, чтобы ваш портал был доступен по адресу docs.yourdomain.com, просто введите это в это поле.",
          "PLACEHOLDER": "Пользовательский домен портала",
          "EDIT_BUTTON": "Редактировать пользовательский домен",
          "ADD_BUTTON": "Добавить пользовательский домен",
          "DIALOG": {
            "ADD_HEADER": "Добавить пользовательский домен",
            "EDIT_HEADER": "Редактировать пользовательский домен",
            "ADD_CONFIRM_BUTTON_LABEL": "Добавить домен",
            "EDIT_CONFIRM_BUTTON_LABEL": "Обновить домен",
            "LABEL": "Свой домен",
            "PLACEHOLDER": "Пользовательский домен портала",
            "ERROR": "Требуется пользовательский домен"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Настройка DNS",
            "DESCRIPTION": "Войдите в учетную запись у вашего DNS-провайдера и добавьте указанную ниже запись CNAME для вашего поддомена.",
            "HELP_TEXT": "Как только это будет сделано, вы можете обратиться в нашу службу поддержки, чтобы запросить автоматически создаваемый SSL-сертификат.",
            "CONFIRM_BUTTON_LABEL": "Понял!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Удалить {portalName}",
          "HEADER": "Удалить портал",
          "DESCRIPTION": "Окончательно удалить этот портал. Это действие необратимо",
          "DIALOG": {
            "HEADER": "Вы уверены, что хотите удалить {portalName}?",
            "DESCRIPTION": "Это необратимое действие, которое нельзя отменить.",
            "CONFIRM_BUTTON_LABEL": "Удалить"
          }
        },
        "EDIT_CONFIGURATION": "Изменить конфигурацию"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Портал создан успешно",
          "ERROR_MESSAGE": "Невозможно создать портал"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Портал успешно обновлен",
          "ERROR_MESSAGE": "Не удалось обновить портал"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Вложения",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Добавить файл",
      "DROP_HERE": "Перетащите файлы сюда",
      "COPY_LINK": "Скопировать ссылку",
      "LINK_COPIED": "Ссылка скопирована в буфер обмена",
      "COPY_FAILED": "Не удалось скопировать ссылку",
      "DELETE": "Удалить",
      "CANCEL": "Отменить",
      "QUEUED": "В очереди",
      "UPLOADING": "Загрузка",
      "UPLOAD_FAILED": "Не удалось загрузить файл",
      "FILE_TOO_LARGE": "Файл превышает лимит 40 МБ"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Словарь переводов",
        "DESCRIPTION": "Термины, указанные здесь, добавляются в промпт AI-перевода, чтобы они всегда переводились одинаково. Ключевой термин указан на языке {locale}."
      },
      "NEW_TERM": "Новый термин",
      "EMPTY_STATE": {
        "TITLE": "Пока нет терминов словаря",
        "SUBTITLE": "Добавьте термин и его перевод для каждого языка. При переводе статьи эти термины применяются, чтобы формулировки вашего продукта оставались единообразными."
      },
      "LIST": {
        "TERM": "Термин",
        "TRANSLATIONS": "Переводы",
        "ACTIONS": "Действия"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Добавить термин",
          "EDIT": "Редактировать термин",
          "DESCRIPTION": "Термин ниже применяется при AI-переводе статей вашего центра поддержки.",
          "PORTAL": "Портал",
          "PRIMARY_LANGUAGE": "Основной язык"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Термин ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Необходимо указать термин"
          },
          "DESCRIPTION": {
            "LABEL": "Контекст / примечания (необязательно)",
            "PLACEHOLDER": "Когда и как используется этот термин — чтобы помочь переводчику избежать неоднозначности."
          },
          "TRANSLATIONS": "Переводы",
          "TRANSLATION_PLACEHOLDER": "Оставьте пустым, чтобы AI переводил термин свободно",
          "AUTO_TRANSLATE": {
            "BUTTON": "Автоперевод на все языки",
            "CONFIRM": "Перевести на {count} языков с помощью AI?",
            "CONFIRM_BUTTON": "Перевести",
            "CANCEL": "Отменить",
            "SUCCESS": "Переводы созданы — проверьте и сохраните",
            "ERROR": "Не удалось выполнить автоперевод, попробуйте ещё раз"
          }
        },
        "BUTTONS": {
          "CREATE": "Добавить термин",
          "EDIT": "Сохранить",
          "CANCEL": "Отменить"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Термин успешно добавлен",
            "ERROR_MESSAGE": "Не удалось добавить термин, попробуйте еще раз"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Термин успешно обновлён",
            "ERROR_MESSAGE": "Не удалось обновить термин, попробуйте еще раз"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Удалить термин",
          "DESCRIPTION": "Вы уверены, что хотите удалить этот термин? Он больше не будет учитываться при переводе.",
          "CONFIRM": "Удалить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Термин успешно удалён",
          "ERROR_MESSAGE": "Не удалось удалить термин, попробуйте еще раз"
        }
      }
    }
  }
}
